import React from 'react';

function CardsProgressSteps({ currentStep = 1, stepLabels = ["Card Info", "Customize Card", "Fund Card", "Review Card"] }) {
    // const stepLabels = ["Card Type", "Customize Card", "Fund Card", "Review Card"];
    const totalSteps = stepLabels.length;

    return (
        <div className="step-container my-2">
            {/* Progress Line */}
            <div className="step-line">
                <div
                    className="step-line-progress"
                    style={{ width: `${((currentStep - 1) / (totalSteps - 1)) * 100}%` }}
                />
            </div>

            {/* Step Dots and Labels */}
            <div className="steps-wrapper">
                {[...Array(totalSteps)].map((_, index) => {
                    const isActive = index + 1 === currentStep;
                    const isCompleted = index + 1 < currentStep;

                    return (
                        <div key={index} className="step">
                            <div className={`step-dot ${isActive ? 'active' : ''} ${isCompleted ? 'completed' : ''}`}>
                                {index + 1}
                            </div>
                            <span className={`step-label ${isActive || isCompleted ? 'active' : ''}`}>
                                {stepLabels[index]}
                            </span>
                        </div>
                    );
                })}
            </div>
        </div>
    );
}

export default CardsProgressSteps;